/**
 * Which sky materials read the DirectionalLights. The procedural and the physical sky read `LIGHT0`
 * (`sky_material.cpp:326`, `:766`), and the panorama reads only its texture (`:502`).
 */
export function materialReadsLights(material) {
    return material.kind !== 'panorama';
}
//# sourceMappingURL=readsLights.js.map